import React from "react";

interface Props {
  upvoteCount: number;
  totalVotes: number;
}

const HelpfulReviewTotal = ({ upvoteCount, totalVotes }: Props) => {
  return (
    <p
      className="text-gray-700 text-sm leading-4 mb-0"
      data-testid="helpful-count"
    >
      {upvoteCount} out of {totalVotes} found this{" "}
      <span className="block">review helpful</span>
    </p>
  );
};

export default HelpfulReviewTotal;
